import { render, staticRenderFns } from "./order-make.vue?vue&type=template&id=15bb48dc&"
import script from "./order-make.vue?vue&type=script&lang=js&"
export * from "./order-make.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports